import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { SessionAuthPayload } from '../interfaces/session-auth';

export const authEvents = eventGroup({
  source: 'Auth',
  events: {
    // --- App init flow ---
    initAuth: type<void>(),

    // --- Generic session materialization (dispatched by tenant-specific login flows once
    // they've obtained a session, e.g. after an OAuth exchange) ---
    setSessionAuth: type<SessionAuthPayload>(),

    // --- General ---
    logout: type<void>(),
  },
});
